"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledListbox = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ListboxMixin = require("../../mixins/components/ListboxMixin");
var StyledListbox = /*#__PURE__*/_styledComponents.default.ul.withConfig({
  displayName: "StyledListbox",
  componentId: "c11n-8-107-0__sc-xd2iit-0"
})(["", ""], _ListboxMixin.ListboxMixin);
exports.StyledListbox = StyledListbox;